module.exports = __webpack_public_path__ + "img/rey.2a6f10d5.webp";